const modalContainer = document.querySelector(".modal__container");
const modal = document.querySelector(".modal");

export { modalContainer, modal };
